import React from "react";
import { useSelector } from "react-redux";
import StackedPieChart from "../../../components/charts/stackedPieChart/stackedPieChart";

export const MembershipActivityPieChart = () => {
  const {
    displayFrozenMembers,
    frozenMembers,
    frozenMembersRawDataLink,
    frozenMembersChange,
    newMembers,
    newMembersRawDataLink,
    churnMembers,
    churnMembersRawDataLink,
    activeMembers,
    activeMembersRawDataLink,
    activeMembersChange
  } = useSelector((state) => state.studioInfo.membershipActivityValues.data);

  const frozen = displayFrozenMembers
    ? [
        {
          title: "Frozen Members",
          negIsPositive: true,
          value: frozenMembers,
          valueRawDataLink: frozenMembersRawDataLink,
          percentChange: frozenMembersChange
        }
      ]
    : [];

  const chartStats = [
    {
      title: "Members",
      value: activeMembers,
      valueRawDataLink: activeMembersRawDataLink,
      percentChange: activeMembersChange
    },
    ...frozen
  ];

  return (
    <StackedPieChart
      clickablePie
      width={650}
      legendsTooltipId="membership-activity-legends-tooltip"
      data={[
        {
          revenueType: "New",
          revenue: newMembers,
          url: newMembersRawDataLink
        },
        {
          revenueType: "Cancelled",
          revenue: churnMembers,
          url: churnMembersRawDataLink
        }
      ]}
      chartStats={chartStats}
    />
  );
};
